import { action } from 'satcheljs';

export const openSharingDialog = action('OPEN_SHARING_DIALOG');
export const closeSharingDialog = action('CLOSE_SHARING_DIALOG');
